import Backbone from 'backbone';
import { InputControl } from '@bingads-webui/input-control';
import template from './edit-control-template.pug';

export default class EditControl extends Backbone.View {
  initialize({ entity, field, description }) {
    this.description = description;
    this.errorMessage = '';

    if (entity && field) {
      this.entity = entity;
      this.field = field;

      this.hotelNameInput = new InputControl({
        entity,
        field,
        ariaLabelledby: 'edit-control-description',
      });
    }

    return this;
  }

  render() {
    this.$el.html(template({
      description: this.description,
      errorMessage: this.errorMessage,
    }));

    if (this.hotelNameInput) {
      this.hotelNameInput.render();
      this.$('.edit-control__container').html(this.hotelNameInput.$el);
    }

    return this;
  }

  setErrorMessage(errorMessage) {
    this.errorMessage = errorMessage;

    this.render();
  }
}
